export default __webpack_public_path__ + "static/media/FullLogo.e7d3deca.png";